import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PublicoRoutingModule } from './publico-routing.module';

import { HomeComponent } from './home/home.component';
import { DespliegueComponent } from './despliegue/despliegue.component';
import { FiltrosDespliegueComponent } from './despliegue/filtros/filtros.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { EstadisticasComponent } from './estadisticas/estadisticas.component';
import { MetricasGlobalesComponent } from './estadisticas/metricas-globales/metricas-globales.component';
import { MetricasEmpresaComponent } from './estadisticas/metricas-empresa/metricas-empresa.component';
import { PipesModule } from '../shared/pipes/pipes.module';
import { PocComponent } from './poc/poc.component';
import { CognitoComponent } from './cognito/cognito.component';
import { CognitoutComponent } from './cognitout/cognitout.component';

import { NgxCaptchaModule } from 'ngx-captcha';

@NgModule({
  declarations: [
    HomeComponent,
    FiltrosDespliegueComponent,
    DespliegueComponent,
    EstadisticasComponent,
    MetricasGlobalesComponent,
    MetricasEmpresaComponent,
    PocComponent,
    CognitoComponent,
    CognitoutComponent
  ],
  imports: [CommonModule, PublicoRoutingModule, SharedModule, FormsModule, PipesModule, NgxCaptchaModule],
  exports: [HomeComponent, CognitoComponent, CognitoutComponent]
})
export class PublicoModule {}
